export enum TimesheetLaborDistributionType {
    PAYROLL = 'PAYROLL', TIMESHEET = 'TIMESHEET'
}